import * as types from '../const/action.types';
import { get, post, put, del } from '../api/_basic';

export function all() {
    return async (dispatch) => {
        dispatch(temometresHasErrored(false, ''));
        dispatch(temometresIsLoading(true));
        return get(`${process.env.REACT_APP_API_INSTALATION}`)
            .then((response) => {
                dispatch(temometresIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(temometresHasErrored(false, ''));
                dispatch(loadTemometresSuccess(items));
            })
            .catch((error) => {
                dispatch(temometresIsLoading(false));
                dispatch(temometresHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function add(temometre) {
    return async (dispatch) => {
        dispatch(temometreIsSaving(true));
        return post(`${process.env.REACT_APP_API_INSTALATION}`, temometre)
            .then((response) => {
                dispatch(temometreIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function edit(termometre) {
    return async (dispatch) => {
        dispatch(temometreIsSaving(true));
        return put(`${process.env.REACT_APP_API_INSTALATION}/${termometre.id}`, termometre)
            .then((response) => {
                dispatch(temometreIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function remove(termometre) {
    return async (dispatch) => {
        return del(`${process.env.REACT_APP_API_INSTALATION}/${termometre}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function getTermometre(termometre) {
    return async function(dispatch) {
        dispatch(temometresHasErrored(false, ''));
        dispatch(temometresIsLoading(true));
        return get(`${process.env.REACT_APP_API_INSTALATION}/${termometre}`)
            .then((response) => {
                dispatch(temometresIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(temometresHasErrored(false, ''));
                dispatch(loadTemometreSuccess(item));
            })
            .catch((error) => {
                dispatch(temometresHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function getFields(local) {
    return async function(dispatch) {
        return get(`${process.env.REACT_APP_API_INSTALATION_SENSOR}/${local}/camposdisponibles`)
            .then((response) => {
                dispatch(temometresIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(loadTemometreFieldSuccess(item));
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function getData(id) {
    return async function(dispatch) {
        return get(`${process.env.REACT_APP_API_INSTALATION_SENSOR}/${id}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((data) => {
                let value = undefined;
                if (data && data.medidas && data.medidas[0]) {
                    value = data.medidas[0].medida;
                }
                console.log(value);
                return value;
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function loadTemometreFieldSuccess(data) {
    return {
        type: types.LOAD_TERMOMETRE_FIELDS_SUCCESS,
        data,
    };
}

export function loadTemometreSuccess(data) {
    return {
        type: types.LOAD_TERMOMETRE_SUCCESS,
        data,
    };
}

export function loadTemometresSuccess(data) {
    return {
        type: types.TERMOMETRES_SUCCESS,
        data,
    };
}

export function temometresHasErrored(bool, message) {
    return {
        type: types.TERMOMETRES_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function temometresIsLoading(bool) {
    return {
        type: types.TERMOMETRES_IS_LOADING,
        isLoading: bool,
    };
}

export function temometreIsSaving(bool) {
    return {
        type: types.TERMOMETRES_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/termometre.actions.js